import { Outlet } from 'react-router-dom';

import { ROUTES } from '../../../constants/routes';

import AdminLoginPage from '../../../pages/login/admin';
import WithNotAuth from 'shared/components/hocs/with-not-auth';

export const ADMIN_LOGIN_ROUTE = {
  path: '',
  element: (
    <WithNotAuth>
      <Outlet />
    </WithNotAuth>
  ),
  children: [
    {
      path: ROUTES.LOGIN.path,
      element: <AdminLoginPage />,
    },
  ],
};
